import { io } from 'socket.io-client';
import config from '../config';

let socket = null;
let socketToken = null;
const sendCallbacks = new Set();

const handleSend = (data) => {
  sendCallbacks.forEach((callback) => callback(data));
};

const connect = (token) => {
  if (!token) return null;

  if (socket) {
    if (socketToken === token) {
      if (socket.disconnected) {
        socket.connect();
      }
      return socket;
    }

    socket.off('send', handleSend);
    socket.disconnect();
    socket = null;
  }

  socketToken = token;

  socket = io(`${config.API_BASE_URL}/notification`, {
    path: '/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
  });

  socket.on('send', handleSend);

  return socket;
};

const onSend = (callback) => {
  sendCallbacks.add(callback);
  return () => sendCallbacks.delete(callback);
};

const disconnect = () => {
  if (!socket) return;

  socket.off('send', handleSend);
  socket.disconnect();
  socket = null;
  socketToken = null;
};

const NotificationService = {
  connect,
  onSend,
  disconnect,
};

export default NotificationService;
